var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"l-app"},[_c('Menu'),_c('div',{staticClass:"l-app__content"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }